var exports = {
  "zr": "GameActivityIcon.module__root___ejBHUm",
  "Sl": "GameActivityIcon.module__image___ejBHUm",
  "Np": "GameActivityIcon.module__fallback___ejBHUm",
};

module.exports = exports;
